import Vue, { reactive } from 'vue';

const useImageLoading = () => {
  const imagesLoading = reactive({ urls: {} });
  const watchImage = (el) => {
    if (!el) {
      return;
    }
    const image = el;
    if (image.complete) {
      return;
    }
    Vue.set(imagesLoading.urls, image.src, true);
    const handler = () => {
      Vue.delete(imagesLoading.urls, image.src);
    };
    image.addEventListener("load", handler);
    image.addEventListener("error", handler);
  };
  const imageLoading = (url) => !!imagesLoading.urls[url];
  return {
    imageLoading,
    watchImage
  };
};

export { useImageLoading };
